import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConnectSQLMutation } from "./generalApiSlice";

const ConnectsqlForm = ({ closeModal }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    DatabaseType: "",
    host: "",
    user: "",
    password: "",
    port: "",
  });
  console.log(formData);
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [connectSQL, { data, isError, isSuccess, isLoading, error }] =
    useConnectSQLMutation();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    connectSQL(formData);
  };

  if (isLoading) {
    console.log("loading...");
  }
  if (isError) {
    console.log(error["data"]["error"]);
  }
  if (isSuccess) {
    console.log(data);
    }

  useEffect(() => {
    if (data && data.message && data.connectionId && data?.databases) {
      const timer = setTimeout(() => {
       const response = data?.databases;
        navigate(`/dataconfigure?connectionId=${data.connectionId}`, { state: { response } });
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <form
        className="flex flex-col gap-2 w-full items-center justify-start"
        onSubmit={handleFormSubmit}
      >
        <div className="flex flex-col w-full px-2 gap-1 text-left">
          <label htmlFor="host" className="font-medium">
            Host
          </label>
          <input
            type="text"
            name="host"
            value={formData.host}
            onChange={handleInputChange}
            className="border border-gray-200 rounded px-2 w-full text-base focus:outline-none"
            required
          />
        </div>
        <div className="flex flex-col w-full px-2 gap-1 text-left">
          <label htmlFor="port" className="font-medium">
            Port
          </label>
          <input
            type="text"
            name="port"
            value={formData.port}
            onChange={handleInputChange}
            className="border border-gray-200 rounded px-2 w-full text-base focus:outline-none"
            required
          />
        </div>
        <div className="flex flex-col w-full px-2 gap-1 text-left">
          <label htmlFor="DatabaseType" className="font-medium">
            Database
          </label>
          <input
            type="text"
            name="DatabaseType"
            value={formData.DatabaseType}
            onChange={handleInputChange}
            className="border border-gray-200 rounded px-2 w-full text-base focus:outline-none"
            required
          />
        </div>
        <div className="flex flex-col w-full px-2 gap-1 text-left">
          <label htmlFor="user" className="font-medium">
            Username
          </label>
          <input
            type="text"
            name="user"
            value={formData.user}
            onChange={handleInputChange}
            className="border border-gray-200 rounded px-2 w-full text-base focus:outline-none"
            required
          />
        </div>
        <div className="flex flex-col w-full px-2 gap-1 text-left">
          <label htmlFor="password" className="font-medium">
            Password
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            className="border border-gray-200 rounded px-2 w-full text-base focus:outline-none"
            required
          />
        </div>
        <div className="flex w-full p-2 gap-1 items-cemter justify-end">
          <button
            className="border py-1 px-2 tracking-wide text-gray-700 hover:bg-gray-200"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="border py-1 px-2 tracking-wide text-white bg-blue-950"
            type="submit"
          >
            {isLoading ? "Connecting..." : "Connect"}
          </button>
        </div>
      </form>
      {isSuccess && (
        <div className="flex w-full items-center justify-center py-1 px-2 text-green-500">
          {data?.message}
        </div>
      )}
      {isError && (
        <div className="flex w-full items-center justify-center py-1 px-2 text-red-500">
          {error["data"]["error"]}
        </div>
      )}
    </>
  );
};

export { ConnectsqlForm };
